import { useQuery } from "@graphcommerce/graphql"
import { Image } from "@graphcommerce/image"
import { GetCertificatesDocument } from "../../graphql/certificates/Certificates.gql"




// eslint-disable-next-line import/no-default-export
export default function CertificatesShow() {

  const { data } = useQuery(GetCertificatesDocument)
  const certificates = data?.getCertificates;


  const showCertificate = (cert) => {

    if (cert?.script)
      return cert.script;
    if (cert?.image)
      return (<Image width={130} height={130} src={cert?.image} />)
    return null;
  }

  return (<div className="flex min-w-[400px] md:min-w-[80px]  flex-row md:flex-col gap-2 justify-center">

    {certificates?.map(certificate =>
      <div className="w-10 h-10">
        {showCertificate(certificate)}
      </div>
    )}
  </div>)
}